import { Grid2 as Grid, Grid2Props, styled } from "@mui/material";
import Stack from "@mui/material/Stack";
import { isNil } from "ramda";
import React, { FC, memo } from "react";
import { useWatch } from "react-hook-form";
import { RowMenu } from "./RowMenu";
import {
  RateConditionInput
} from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/RateConditionInput";
import { RateInputs } from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/RateInputs";
import { RatelistRowName } from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/RatelistRowName";
import { RateBuilderTreeFormFields } from "@sinch/components/application/RatelistBuilder/ratelistBuilderSchema";
import {
  useRateBuilderSettings
} from "@sinch/components/application/RatelistBuilder/UtilitiesProviders/RateBuilderSettingsProvider";
import { IntersectionRenderer } from "@sinch/components/IntersectionRenderer/IntersectionRenderer";

export const RateBuilderRowContent: FC<{ rowId: string }> = memo(({ rowId }) => {
  const val = useWatch<RateBuilderTreeFormFields>({ name: `Rate.${rowId}`, exact: true });
  const { mode, disableConditions } = useRateBuilderSettings();
  // This condition prevent render row before data from tree are propagated into form
  if (isNil(val)) {
    return null;
  }
  return (
    <IntersectionRenderer>
      <Stack sx={{ minWidth: "320px" }}>
        <RatelistRowName rowId={rowId} />
        <Grid alignItems="center" container spacing={1} sx={{ padding: "1px" }}>
          <Grid size="grow">
            <RateBuilderRowContainer container spacing={1}>
              {!disableConditions && <RateConditionInput rowId={rowId} />}
              <RateInputs fullWidth={disableConditions} rowId={rowId} />
            </RateBuilderRowContainer>
          </Grid>
          {mode === 'edit' && (
            <Grid size="auto">
              <RowMenu rowId={rowId} />
            </Grid>
          )}
        </Grid>
      </Stack>
    </IntersectionRenderer>
  );
});
RateBuilderRowContent.displayName = "RateBuilderRowContent";

export const RateBuilderRowContainer = styled(Grid)({
  containerType: "inline-size",
});

export const RateBuilderRowContentItem = styled(Grid)<Grid2Props>(({ theme }) => ({
  "&.RateBuilderRowContentItem-half": {
    [theme.containerQueries.down(800)]: {
      width:
        "calc(100% * 6 / var(--Grid-parent-columns) - (var(--Grid-parent-columns) - 6) * (var(--Grid-parent-columnSpacing) / var(--Grid-parent-columns)));",
    },
    [theme.containerQueries.down(450)]: {
      width: "100%",
      flexBasis: "auto",
      flexGrow: 0,
    },
  },
  "&.RateBuilderRowContentItem-full": {
    [theme.containerQueries.down(800)]: {
      width: "100%",
      flexBasis: "auto",
      flexGrow: 0,
    },
  },
}));
